// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {VueMasonryPlugin} from 'vue-masonry'
import ToggleButton from 'vue-js-toggle-button'
import VueResource from 'vue-resource'

Vue.config.productionTip = false

// Vue use
Vue.use(VueMasonryPlugin)
Vue.use(ToggleButton)
Vue.use(VueResource)

Vue.http.options.emulateJSON = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js